/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submitting_Ad_JobInputs */

const en_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting job for processing...`)
};

const fr_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumission de la tâche pour traitement...`)
};

const de_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftrag wird zur Bearbeitung übermittelt...`)
};

const it_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio della richiesta di elaborazione in corso...`)
};

const ru_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка задания на обработку...`)
};

const es_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando trabajo para su procesamiento...`)
};

const zh_cn2_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在提交作业进行处理……`)
};

const ja_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理のためにジョブを送信しています...`)
};

const hi_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रक्रिया के लिए कार्य प्रस्तुत किया जा रहा है...`)
};

const pt_pt2_submitting_ad_job = /** @type {(inputs: Submitting_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando trabalho para processamento...`)
};

/**
* | output |
* | --- |
* | "Submitting job for processing..." |
*
* @param {Submitting_Ad_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submitting_ad_job = /** @type {((inputs?: Submitting_Ad_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submitting_Ad_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submitting_ad_job(inputs)
	if (locale === "de") return de_submitting_ad_job(inputs)
	if (locale === "it") return it_submitting_ad_job(inputs)
	if (locale === "ru") return ru_submitting_ad_job(inputs)
	if (locale === "es") return es_submitting_ad_job(inputs)
	if (locale === "zh-CN") return zh_cn2_submitting_ad_job(inputs)
	if (locale === "ja") return ja_submitting_ad_job(inputs)
	if (locale === "hi") return hi_submitting_ad_job(inputs)
	if (locale === "pt-PT") return pt_pt2_submitting_ad_job(inputs)
	return en_submitting_ad_job(inputs)
});